export default "__VITE_ASSET__BKhEVYLF__"